import { exchangeRate } from "./exchangeRate";

export const queryHooks = { exchangeRate };
